import { render, staticRenderFns } from "./po_send_two.vue?vue&type=template&id=3a00688c&scoped=true&"
import script from "./po_send_two.vue?vue&type=script&lang=js&"
export * from "./po_send_two.vue?vue&type=script&lang=js&"
import style0 from "./po_send_two.vue?vue&type=style&index=0&id=3a00688c&scoped=true&lang=less&"
import style1 from "./po_send_two.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a00688c",
  null
  
)

export default component.exports